import Vue from 'vue';
import Buefy from 'buefy';
import { extend, configure, ValidationProvider } from 'vee-validate';
import {
  required, email, min, ext, confirmed,
} from 'vee-validate/dist/rules';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import checkPasswordStrength, { DiversityType, Options } from 'check-password-strength';
import i18n from './i18n';
import App from './App.vue';
import router from './router';
import store from './shared/store';
import './assets/scss/app.scss';
import helpers from '@/helpers';

// TODO: move this?

let environment = 'dev';

switch (process.env.NODE_ENV) {
  case 'live':
    environment = 'production';
    break;

  case 'staging':
    environment = 'staging';
    break;

  default:
}

// VeeValidate

// Use the vue-i18n locales for messages
configure({
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  defaultMessage: (_, values) => i18n.t(`validations.${values._rule_}`, values),
});

// Only add rules used. This keeps the bundle size down.
extend('required', required);
extend('email', email);
extend('min', min);
extend('ext', ext);
extend('confirmed', confirmed);

extend('complexity', (value) => {
  const strengthConfig : Options<string> = [
    {
      id: 0,
      value: 'Too weak',
      minDiversity: 0,
      minLength: 0,
    },
    {
      id: 1,
      value: 'Weak',
      minDiversity: 1,
      minLength: 8,
    },
    {
      id: 2,
      value: 'Medium',
      minDiversity: 2,
      minLength: 10,
    },
    {
      id: 3,
      value: 'Strong',
      minDiversity: 3,
      minLength: 12,
    },
  ];

  const currentPasswordStrength = checkPasswordStrength.passwordStrength(value, strengthConfig, '!@#$%^&*"€/()=+?¡[]\'§£;,:.-_><');

  if (currentPasswordStrength.contains.length > 3) {
    return true;
  }

  const getMissingCharacterCategoriesString = (currentPasswordStrengthContains: DiversityType[]|undefined) => {
    const characterCategoryTranslations: {[k in DiversityType]: string} = {
      lowercase: 'små bogstaver',
      uppercase: 'store bogstaver',
      symbol: 'symboler',
      number: 'tal',
    };

    const possibleCharacterCategories: DiversityType[] = ['lowercase', 'uppercase', 'number', 'symbol'];

    return helpers.join(possibleCharacterCategories.filter(n => currentPasswordStrengthContains && !currentPasswordStrengthContains.includes(n)).map(key => characterCategoryTranslations[key]), 'or');
  };

  return `Kodeordet er for simpelt: Tilføj ${getMissingCharacterCategoriesString(currentPasswordStrength.contains)}`;
});

Vue.component('ValidationProvider', ValidationProvider);

// Buefy
Vue.use(Buefy);

Vue.config.productionTip = false;

if (environment === 'production' || environment === 'staging') {
  Sentry.init({
    dsn: 'https://8fde9a074dc9413fa9ba150a081b7048@sentry.io/1792156',
    environment,
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true,
      logErrors: true,
    })],
  });
}

new Vue({
  router,
  store,
  i18n, // I18N
  render: h => h(App),
}).$mount('#app');
